module.exports = __webpack_public_path__ + "img/symbol_4.638c1549.png";